/* eslint-disable no-unused-vars */
import moment from 'moment';
import { useEffect, useState } from 'react';
import DatePicker from "react-datepicker";
import dayjs from 'dayjs';
import { getMinute } from '../../Utils/Function';
import FormInput from '../Ui/FormInput';

interface Props {
    value: any
    date: any
    setEndTime: (date: Date) => void
    setStartTime: (date: Date) => void
    duration: number
    label: string
    customPrice?: string
    today?: any
    endValue?: any
    error?: boolean
    errorMsg?: string
    setIsOver?: (isOver: boolean) => void
    startAt?: any
    placeholder?: string
    required?: boolean
}

const TimeFields = ({
    value, date, setEndTime, setStartTime, duration, label,
    customPrice, setIsOver, startAt, error, errorMsg, required,
    placeholder = 'Ex : 17:00',
}: Props) => {
    const [selectedTime, setSelectedTime] = useState<any>();
    // Plusieurs séances affichent plusieurs sélecteurs empilés, chacun dans
    // son propre contexte z-40 : la liste d'heures du premier passait sous le
    // champ du suivant. Seul le sélecteur ouvert monte au-dessus des autres.
    const [isOpen, setIsOpen] = useState(false);
    const today = new Date();

    useEffect(() => {
        const isValidDate = value instanceof Date && !isNaN(value.getTime());
        setSelectedTime(isValidDate ? value : undefined);
    }, [value]);

    const handleChange = (newValue: any) => {
        let startTimes = moment(newValue);
        let startDates = date && dayjs.isDayjs(date)
            ? moment(date.format('YYYY-MM-DD'))
            : moment(date);
        let startDateTimeValid = startDates
            .set("hour", startTimes.hours())
            .set("minutes", startTimes.minutes())
            .toDate();
        let endDateTimeValid = moment(startDateTimeValid).add(duration, "hours").toDate();
        const startOfMonth = moment().startOf('month');
        const fourAM = startOfMonth.clone().hour(4);

        if (setIsOver) {
            setIsOver(endDateTimeValid < today);
        }
        if (startDates.isSame(startOfMonth, 'day') && startDates.isBefore(fourAM)) {
            setSelectedTime(fourAM.toDate());
            setStartTime(fourAM.toDate());
            setEndTime(moment(fourAM.toDate()).add(duration, "hours").toDate());
        } else {
            // Date choisie + heure saisie, à la minute : la date de validation du
            // compte porte des secondes, l'heure proposée ne doit pas en hériter.
            if (startAt && moment(startAt).isValid() && moment(startDateTimeValid).isBefore(moment(startAt).add(2.5, 'hours').startOf('minute'))) {
                const startAtMinute = moment(startAt).add(2.5, 'hours').startOf('minute');
                const endAtMinute = moment(startAtMinute).add(duration, "hours");
                const startMinute = getMinute(startAtMinute.minute());
                const endMinute = getMinute(endAtMinute.minute());
                setSelectedTime(startAtMinute.toDate());
                setStartTime(moment(startAtMinute).minute(startMinute).toDate());
                setEndTime(moment(endAtMinute).minute(endMinute).toDate());
            } else {
                setSelectedTime(newValue);
                setStartTime(newValue);
                setEndTime(moment(newValue).add(duration, "hours").toDate());
            }
        }
    };

    return (
        <div className={`relative w-full ${isOpen ? 'z-50' : 'z-40'} ${customPrice}`}>
            <DatePicker
                selected={selectedTime}
                onChange={handleChange}
                showTimeSelect
                showTimeSelectOnly
                timeCaption="Heure"
                timeIntervals={5}
                dateFormat="HH:mm"
                timeFormat="HH:mm"
                placeholderText={placeholder}
                customInput={
                    <FormInput
                        label={label}
                        placeholder={placeholder}
                        required={required}
                        error={error ? errorMsg : undefined}
                    />
                }
                popperProps={{ strategy: 'fixed' }}
                onCalendarOpen={() => setIsOpen(true)}
                onCalendarClose={() => setIsOpen(false)}
            />
        </div>
    );
};

export default TimeFields;
